<template>
  <div>
    <Panel />
  </div>
</template>

<script>
export default {
  name: 'Campaigns'
}
</script>

<style>

</style>